import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ children }) => {
  const token = Cookies.get('usr');
  if (!token) {
    // Si no hay token, redirige al usuario a la página de inicio de sesión
    return <Navigate to="/" replace />;
  }

  // Si el token existe, renderiza el componente hijo (la ruta protegida)
  return children ? children : <Outlet />;
};

export default ProtectedRoute;